import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const [mobileMenu, setMobileMenu] = useState(false);

  const movePage = (path) => {
    navigate(path);
    window.location.reload();
  };
  const openMenu = () => {
    setMobileMenu(!mobileMenu);
  };

  return (
    <div className="header_wrap">
      <div className="header_back">
        <div className="header_logo_box" onClick={() => movePage("/")}>
          <div className="header_logo"></div>
        </div>
        <div className="header_menu_box">
          <div className="header_menu">
            키움성장소개
            <div className="sub_menu_box">
              <div className="sub_menu" onClick={() => movePage("/intro")}>
                의료진 소개
              </div>
              <div className="sub_menu" onClick={() => movePage("/clinic")}>
                병원 둘러보기
              </div>
              <div className="sub_menu" onClick={() => movePage("/nonbenefit")}>
                비급여 고지
              </div>
              <div className="sub_menu" onClick={() => movePage("/map")}>
                진료 안내
              </div>
            </div>
          </div>
          <div className="header_menu" onClick={() => movePage("/grow")}>
            성장클리닉
          </div>
          <div className="header_menu" onClick={() => movePage("/disease")}>
            성조숙증
          </div>
          <div className="header_menu">
            커뮤니티
            <div className="sub_menu_box">
              <div className="sub_menu" onClick={() => movePage("/info")}>
                중요 성장 정보
              </div>
              <div className="sub_menu" onClick={() => movePage("/commu")}>
                방송출연 영상
              </div>
              <div className="sub_menu" onClick={() => movePage("/review")}>
                고객 리뷰
              </div>
            </div>
          </div>
        </div>
        <div className="header_mobile_menu_box">
          <div className="menu_icon" onClick={() => openMenu()}></div>
        </div>
      </div>
      <div className={`mobile_back ${mobileMenu && "active"}`}>
        <div className="close_btn_box">
          <div className="close_btn" onClick={() => openMenu()}></div>
        </div>
        <div className="mobile_menu_box">
          <div className="mobile_menu sub" onClick={() => movePage("/intro")}>
            키움성장소개
          </div>
          <div className="sub_menu" onClick={() => movePage("/intro")}>
            의료진 소개
          </div>
          <div className="sub_menu" onClick={() => movePage("/clinic")}>
            병원 둘러보기
          </div>
          <div className="sub_menu" onClick={() => movePage("/nonbenefit")}>
            비급여 고지
          </div>
          <div className="sub_menu" onClick={() => movePage("/map")}>
            진료 안내
          </div>
          <div className="mobile_menu" onClick={() => movePage("/grow")}>
            성장클리닉
          </div>
          <div className="mobile_menu" onClick={() => movePage("/disease")}>
            성조숙증
          </div>
          <div className="mobile_menu sub" onClick={() => movePage("/info")}>
            커뮤니티
          </div>
          <div className="sub_menu" onClick={() => movePage("/info")}>
            중요 성장 정보
          </div>
          <div className="sub_menu" onClick={() => movePage("/commu")}>
            방송출연 영상
          </div>
          <div className="sub_menu" onClick={() => movePage("/review")}>
            고객리뷰
          </div>
        </div>
        {/* <div className="mobile_icon_box">
          <div
            className="mobile_icon gps"
            onClick={() =>
              window.open(
                "https://www.google.com/maps/place/%ED%82%A4%EC%9B%80%EC%86%8C%EC%95%84%EC%B2%AD%EC%86%8C%EB%85%84%EA%B3%BC%EC%9D%98%EC%9B%90/data=!4m6!3m5!1s0x357ca105b63df7df:0x59d4bd1fea306798!8m2!3d37.5043295!4d127.0010666!16s%2Fg%2F11f9_n67bx?entry=ttu"
              )
            }
          ></div>
          <div
            className="mobile_icon naver"
            onClick={() =>
              window.open(
                "https://m.booking.naver.com/booking/13/bizes/472715#"
              )
            }
          ></div>
          <div
            className="mobile_icon youtube"
            onClick={() =>
              window.open("https://youtube.com/@Kiumtv?si=DxftFuul2W62hO8G")
            }
          ></div>
          <div
            className="mobile_icon kakao"
            onClick={() => window.open("http://pf.kakao.com/_xnRukb")}
          ></div>
          <div
            className="mobile_icon blog"
            onClick={() => window.open("https://blog.naver.com/h_kyoung")}
          ></div>
        </div> */}
      </div>
    </div>
  );
};

export default Header;
